





















import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
import { NumberItem } from '@/components/form';
import { Question } from '@/domains/template';

import { comments, commentsLevel } from '@/utils/excel/template/index';

@Component({
  name: 'MultiQuestionTitle',
  components: {
    'my-input-number': NumberItem,
  },
})
export default class MultiQuestionTitle extends Vue {
  private comment: string = '';
  private comments: string[] = comments;

  @Prop()
  private value: Question;

  @Prop({ default: false })
  private save: boolean;

  @Prop({ default: '0' })
  private checkModel: string;

  @Prop()
  private id: number | string;

  // constructor() {
  //   super()
  //   console.log(this.comment);
  // }

  private inputChange(value: string): void {
    this.comment = commentsLevel(value);
  }

  private radiaChange(value: string): void {
    const scores: string[] = ['93', '80', '67', '30'];
    this.question.answer.answer = scores[this.comments.indexOf(value)];
  }

  get question(): Question {
    return this.value;
  }

  set question(value: Question) {
    this.$emit('input', value);
  }

  @Emit('change')
  private change(value: string | number): void { return; }
}
